<template>
  <div class="container-auditor">
    <template v-if="auditor && auditor.fileFlow">
      <template v-for="(item, i) of auditor.fileFlow">
        <div class="title" :key="'fileFlow_title_' + i">
          文件审批{{ auditor.fileFlow.length > 1 ? i + 1 : "" }}
          <!-- 只有一层无法判断审批类型，干脆不展示 -->
          <!-- <span class="isOrder">{{ item.nodes.length > 1 ? "顺序审批" : "会审" }}</span> -->
        </div>
        <div class="content" :key="'fileFlow_' + i">
          <div class="desc" :key="i">
            <p>
              <span class="user-tilte-color">申请人：</span>
              <span>{{ item.createUser }}</span>
            </p>
            <p class="userName">
              <span>{{ item.taskCreateTime }}</span>
            </p>
          </div>
          <p class="tit">
            共{{ item.nodes.length }}方
            <span
              :style="{
                color: colorStatus,
                float: 'right',
                marginRight: '20px'
              }"
              ></span>
          </p>
        </div>
        <template v-for="(node,j) of item.nodes">
          <!-- <div class="chap" :class="status(comstatus(task))">
            <div class="chap-box">{{ statusText(comstatus(task)) }}</div>
          </div> -->
          <div class="content" :key="'fileFlow_' + i + j">
            <div class="obj-box">
              <div
                class="obj"
                v-for="(v, index) in node.taskList"
                :key="index"
              >
                <template v-if="v.userId === dingTalkUserId">
                  <el-tooltip
                    effect="dark"
                    :content="v.name + '(我)'"
                    placement="bottom"
                  >
                    <div class="user">
                      <span class="el-icon-user-solid"></span>
                    </div>
                  </el-tooltip>
                </template>
                <template v-else>
                  <el-tooltip
                    effect="dark"
                    :content="v.name"
                    placement="bottom"
                  >
                    <div class="user">
                      <span class="el-icon-user-solid"></span>
                    </div>
                  </el-tooltip>
                </template>
                <div class="obj-other">
                  <p class="userName">{{ v.name }}</p>
                  <div class="status text-color-green" v-if="comstatus(v) === 1">
                    已同意
                  </div>
                  <div class="status text-color-red" v-if="comstatus(v) === 2">
                    已驳回
                  </div>
                  <div class="status" v-if="comstatus(v) === 0">未审批</div>
                  <div class="time" v-if="v.finishTime">{{ v.finishTime }}</div>
                  <!-- <div class="reason" v-if="v.refuseReason">
                    拒绝原因: {{ v.refuseReason }}
                  </div> -->
                </div>
                &nbsp;&nbsp;
                <el-button 
                  v-if="comstatus(v) === 0"
                  class="approver-bth-sty"
                  plain 
                  type="primary" 
                  size="small"
                  @click="urgeForTrial"
                  >催审</el-button>
              </div>
            </div>
          </div>
          <!-- <template v-for="task of node.taskList">
            <div class="item" :key="'fileFlow_0' + i + j + '_' + task.userId">
              <template v-if="task.userId === dingTalkUserId">
                <el-tooltip
                  effect="dark"
                  :content="task.name + '(我)'"
                  placement="bottom"
                >
                  <div class="user">
                    <span class="el-icon-user-solid"></span>
                  </div>
                </el-tooltip>
              </template>
              <template v-else>
                <el-tooltip
                  effect="dark"
                  :content="task.name"
                  placement="bottom"
                >
                  <div class="user">
                    <span class="el-icon-user-solid"></span>
                  </div>
                </el-tooltip>
              </template>
            </div>
          </template> -->
        </template>
      </template>
    </template>
    <!-- 用印审批 -->
    <ding-sign-approve :signAuditor="auditor.sealFlow" :singInfo="applyInfo"></ding-sign-approve>
  </div>
</template>

<script>
import dingSignApprove from "./dingSignApprove.vue";
import {ApiCorpMethods} from "@/assets/js/http-serve/corp/http-methods";

export default {
  name: "audit-detail",
  components: { dingSignApprove },
  props: {
    auditor: {
      type: Object,
      default() {
        return {
          fileFlow: [],
          sealFlow: []
        };
      }
    },
    applyInfo:{
      type:Object,
      default:{}
    }
  },
  data() {
    return {
      signFlowVisi:false,
      list: [],
      leader: {},
      isOrder: true // true 顺序签 false 会审
    };
  },
  computed: {
    dingTalkUserId(){
      const { dingTalkUserId } = JSON.parse(sessionStorage.getItem("dingloginInfo"))
      return dingTalkUserId
    },
    statusText() {
      return function(val) {
        let str = "";
        switch (val) {
          case 0:
            str = "未流转";
            break;
          case 1:
            str = "已通过";
            break;
          case 2:
            str = "未通过";
          default:
            break;
        }
        return str;
      };
    },
    status() {
      return function(val) {
        let str = "";
        switch (val) {
          case 0:
            str = "default";
            break;
          case 1:
            str = "suc";
            break;
          case 2:
            str = "fail";
          default:
            break;
        }
        return str;
      };
    },
    allStatus() {
      //0未审批1审批过2没审批通过3审批中
      const { fileFlow } = this.auditor;
      if (fileFlow[0]) {
        switch (fileFlow[0].flowStatus) {
          case 0:
            return "待审批";
            break;
          case 1:
            return "已通过";
            break;
          case 2:
            return "未通过";
            break;
          case 3:
            return "审批中";
            break;
          default:
            return "";
            break;
        }
      }
    },
    colorStatus() {
      //0未审批1审批过2没审批通过3审批中
      const { fileFlow } = this.auditor;
      if (fileFlow[0]) {
        switch (fileFlow[0].flowStatus) {
          case 1:
            return "#86DEA8";
          case 2:
            return "#EC1C1C";
          case 3:
            return "#FF9900";
          default:
            return "#000000";
        }
      }
    }
  },
  mounted() {
    setTimeout(() => {
      this.signFlowVisi=true
    }, 2*1000);
  },
  methods: {
    /** 处理审批状态 */
    comstatus(obj){
      return obj.result === 'AGREE' ? 1 : obj.result === 'REFUSE' ? 2 : 0
    },
    // 20210304 新增集团催审
    urgeForTrial (sign) {
      var param = {
        applyNo: this.$route.query.applyNo || null
      };
      ApiCorpMethods.SendSms4SignController.reminderApprova(param)
        .then(res => {
          // data参数：{cashierUrl:'', money: '', orderNumber: '', point: ''}
          var data = res.data;
          if (res.success || res.success === "true") {
            if (res.data.recharge) {
              this.$jzqService.pointRechargeTip(); // 积分不足时的充值提示
            } else {
              this.$confirm(
                `<div style="font-weight: bold;color: #606266;font-size: 18px;text-align: center;border: 1px dashed #FCE2E2;padding-bottom: 5px ">
                            <img src="/images/icon_signed.png" style="height: 80px">
                            <p style="margin-top: 10px">需花费：
                            <span style="color: #Ec1C1C">${data.point}积分/次</span></p>
                            <p style="margin-top: 10px;padding: 0 10px;font-weight: 400;font-size: 14px;text-align: start">
                            <i class="el-icon-info" style="margin-right: 5px"></i>
                            确定后，待审批的审批方将收到审批短信通知，该通知72小时有效</p></div>`,
                "温馨提示",
                {
                  showConfirmButton: true,
                  showCancelButton: false,
                  dangerouslyUseHTMLString: true,
                  customClass: "handle-message"
                  // type: 'info',
                }
              ).then(() => {
                ApiCorpMethods.SendSms4SignController.reminderApprova(
                  Object.assign(param, { pay: 1 })
                ).then(res => {
                  if (+res.code === 10806) {
                    this.$jzqService.pointRechargeTip(); // 积分不足时的充值提示
                    return;
                  }
                  if (+res.code === 0) {
                    this.$emit("resetList");
                    return this.$message.success("催审成功");
                  }
                  this.$message.error(res.description || "支付失败");
                });
              });
            }
          } else {
            this.$message.error(res.description);
          }
        })
        .catch(err => {
          this.$message.error(err.description || "数据初始化失败");
        });
    },
    /**
     * 自动换行
     * @param v 值
     * @param number
     */
    autoNewLine(v, number) {
      let d = "";
      for (let index = 0; index < v.length; index++) {
        const element = v[index];
        if (index > 0 && index % number === 0) {
          d += "\r\n";
        }
        d += element;
      }
      return d;
    }
  },
  beforeDestroy() {}
};
</script>
<style>
.el-tooltip__popper {
  max-width: 300px;
  white-space: normal;
  word-break: break-all;
}
</style>
<style scoped lang="less">
@import "../../assets/style/publicVar.css";
.user-tilte-color {
  color: var(--dark-color) !important;
}
.container-auditor {
  width: 100%;
}

.container-auditor .item {
  width: 100%;
  box-sizing: border-box;
  height: 84px;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  margin: 15px 0;
  padding: 0 15px;
  position: relative;

  .user {
    width: 54px;
    height: 54px;
    border-radius: 50%;
    border: 1px solid #eeeeee;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    span {
      font-size: 32px;
      color: #eeeeee;
      border: 4px solid #eeeeee;
      border-radius: 50%;
    }
  }

  .chap {
    position: absolute;
    width: 75px;
    height: 75px;
    box-sizing: border-box;
    border: 2px solid transparent;
    border-radius: 50%;
    display: flex;
    top: -35px;
    right: 110px;
    align-items: center;
    justify-content: center;

    .chap-box {
      border-radius: 50%;
      border: 1px solid transparent;
      width: 62px;
      height: 62px;
      text-align: center;
      line-height: 62px;
      font-size: 16px;
      font-weight: bold;
      transform: rotate(315deg);
    }
  }

  .chap.suc {
    border-color: #86dea8;

    .chap-box {
      border-color: #86dea8;
      color: #86dea8;
    }
  }
  .chap.default {
    border-color: #dddddd;

    .chap-box {
      border-color: #dddddd;
      color: #dddddd;
    }
  }
  .chap.fail {
    border-color: #ec1c1c;

    .chap-box {
      border-color: #ec1c1c;
      color: #ec1c1c;
    }
  }

  .desc {
    width: auto;
    height: 50px;
    flex-direction: column;
    justify-content: space-between;
    margin-left: 15px;

    p {
      font-size: 12px;
      color: #cccccc;

      span {
        margin-left: 20px;
      }
    }

    p.userName {
      color: #000000;
      font-size: 14px;
    }
  }
}

.container-auditor .content {
  width: 100%;
  // height: 560px;
  box-sizing: border-box;
  background-color: #fff;
  position: relative;
  padding: 10px 15px;
  .tit {
    height: 30px;
    line-height: 30px;
    width: 100%;
  }
  .obj-box {
    overflow: auto;
    overflow-x: hidden;
    position: relative;
    width: 100%;
    // height: 510px;
    box-sizing: border-box;
    padding: 10px 0;
  }
  .obj {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: flex-start;
    min-height: 70px;
    height: auto;
    position: relative;
    margin-bottom: 30px;
    .approver-bth-sty{
      position: absolute;
      top: 30px;
      right: 16px;
    }
    &:not(:first-child) {
      /*border-top: 1px #eeeeee dashed;*/
      &:after {
        content: "";
        position: absolute;
        width: 640px;
        border: 1px #eeeeee dashed;
        height: 0px;
        top: -15px;
        left: 86px;
      }
      .user {
        width: 54px;
        height: 54px;
        border-radius: 50%;
        border: 1px solid #eeeeee;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        position: relative;
        span {
          font-size: 32px;
          color: #eeeeee;
          border: 4px solid #eeeeee;
          border-radius: 50%;
        }
      }
    }
    .user {
      width: 54px;
      height: 54px;
      border-radius: 50%;
      border: 1px solid #eeeeee;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      position: relative;
      span {
        font-size: 32px;
        color: #eeeeee;
        border: 4px solid #eeeeee;
        border-radius: 50%;
      }
    }
    .obj-other {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      min-height: 70px;
      height: auto;
      margin-top: 10px;
      margin-left: 30px;
      .status {
        color: rgba(0, 0, 0, 0.65);
      }
      .text-color-red {
        color: red;
      }
      .text-color-green {
        color: #86dea8;
      }
      .reason {
        width: 640px;
        color: red;
        cursor: pointer;
      }
    }
  }
}

.title {
  width: 100%;
  font-weight: bold;
  font-size: 14px;

  .isOrder {
    font-size: 10px;
    padding: 2px 5px;
    color: #ffffff;
    background-color: #f0d092;
  }
}
</style>



// WEBPACK FOOTER //
// components/auditDetail/dingNew.vue